import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tasksReducer from './slices/tasksSlice';
import organizationsReducer from './slices/organizationsSlice';
import notificationsReducer from './slices/notificationsSlice';
import kpiReducer from './slices/kpiSlice';
import chatReducer from './slices/chatSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tasks: tasksReducer,
    organizations: organizationsReducer,
    notifications: notificationsReducer,
    kpi: kpiReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
